import React from 'react'

import { Form } from '_zari/core'

import { MesesContabilidadConstant } from 'constants/index'

const MesContabilidadSelect = props => {
  const selectOpions = React.useMemo(() => {
    const salida = []
    for (let i = 0; i <= 12; i++) {
      const element = MesesContabilidadConstant.__array[i]
      salida.push(
        <option key={i} value={element.id}>
          {element.nombre}
        </option>
      )
    }

    return salida
  }, [])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar </option>
      {selectOpions}
    </Form.Select>
  )
}

export default React.memo(MesContabilidadSelect)
